module.exports = __webpack_public_path__ + "img/more.7e354a96.svg";